import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=3a562d30&lang=pug"
import script from "./WhyChooseUs.vue?vue&type=script&lang=ts"
export * from "./WhyChooseUs.vue?vue&type=script&lang=ts"
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&id=3a562d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports